import { useCallback, useEffect, useState } from 'react';
import { useApiGet } from '@sierralabs/core-ui';
export function useFindSite() {
    const [path, setPath] = useState('');
    const { data, isLoading, error, get } = useApiGet(path);
    // fetch site when path is set
    useEffect(() => void (path && get()), [path, get]);
    // clear out path state after fetching
    useEffect(() => (data ? setPath('') : error ? setPath('') : undefined), [data, error]);
    const findSite = useCallback((siteId) => {
        setPath(`sites/${siteId}`);
    }, []);
    const findSiteByDomain = useCallback((domain, path) => {
        const params = new URLSearchParams({ domain, path }).toString();
        setPath(`sites/domain?${params}`);
    }, []);
    return {
        loadedSite: data,
        loadingSite: isLoading,
        loadingSiteError: error,
        findSite,
        findSiteByDomain
    };
}
//# sourceMappingURL=useFindSite.js.map